<div class="pc-user-toolbar">
  <div class="pc-user-toolbar__summary">
    <h2>Users</h2>
    <span>{{ listUsers?.length || 0 }} team member{{ listUsers?.length === 1 ? '' : 's' }}</span>
  </div>

  <div class="pc-user-toolbar__actions">
    @if (selectedRows.length > 0) {
      <span class="pc-selection-count">{{ selectedRows.length }} selected</span>
      <button mat-stroked-button [matMenuTriggerFor]="bulkMenu">
        Manage selected
        <mat-icon>expand_more</mat-icon>
      </button>
    }
    <button mat-stroked-button (click)="export()">
      <mat-icon>file_download</mat-icon>
      Export
    </button>
    @if (canAddUsers) {
      <button mat-raised-button color="primary" (click)="addUser()">
        <mat-icon>person_add</mat-icon>
        Invite user
      </button>
    }
  </div>
</div>

<mat-menu #bulkMenu="matMenu">
  @if (canAddUsers && canSeeInviteToOtherCompanies) {
    <button mat-menu-item (click)="inviteToOtherCompany()" [disabled]="selectedRows.length !== 1">
      <mat-icon>outgoing_mail</mat-icon>
      <span>Invite to another company</span>
    </button>
  }
  @if (canEnableDisableUsers) {
    <button mat-menu-item (click)="enableSelectedRows()" [disabled]="enableUsersClick">
      <mat-icon>person_outline</mat-icon>
      <span>Enable users</span>
    </button>
    <button mat-menu-item (click)="disableSelectedRows()" [disabled]="disableUsersClick">
      <mat-icon>person_off</mat-icon>
      <span>Disable users</span>
    </button>
  }
  <button mat-menu-item (click)="sendResetPasswordLink()" [disabled]="sendResetPasswordLinkClick">
    <mat-icon>lock_reset</mat-icon>
    <span>Send password reset</span>
  </button>
  @if (canDeleteUsers) {
    <mat-divider></mat-divider>
    <button mat-menu-item class="pc-danger-action" (click)="deleteSelectedRowsClick()" [disabled]="deleteUsersClick">
      <mat-icon>delete</mat-icon>
      <span>Delete users</span>
    </button>
  }
</mat-menu>

<div class="pc-pt-wrapper">
  <p-table
    [value]="listUsers || []"
    dataKey="user.id"
    [(selection)]="selectedRows"
    [loading]="tableLoading"
    [scrollable]="true"
    scrollHeight="calc(100vh - 320px)"
    [paginator]="(listUsers?.length || 0) > 15"
    [rows]="15"
    [rowsPerPageOptions]="[15, 30, 50]"
    [rowHover]="true"
    sortField="user.displayName"
    [sortOrder]="1"
    styleClass="p-datatable-sm pc-user-table"
    currentPageReportTemplate="{first}–{last} of {totalRecords}"
    [showCurrentPageReport]="true">

    <ng-template pTemplate="header">
      <tr>
        <th class="pc-select-column"><p-tableHeaderCheckbox /></th>
        <th pSortableColumn="user.displayName">User <p-sortIcon field="user.displayName" /></th>
        <th pSortableColumn="user.emailAddress">Email <p-sortIcon field="user.emailAddress" /></th>
        <th pSortableColumn="roleName">Role <p-sortIcon field="roleName" /></th>
        <th pSortableColumn="statusLabel">Status <p-sortIcon field="statusLabel" /></th>
        <th class="pc-actions-column"><span class="sr-only">Actions</span></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td class="pc-select-column"><p-tableCheckbox [value]="item" /></td>
        <td>
          <div class="pc-user-identity">
            @if (item.imageUrl) {
              <img [src]="item.imageUrl" [alt]="item.user.displayName || 'User'" />
            } @else {
              <span class="pc-user-avatar">{{ userInitials(item.user) }}</span>
            }
            <div>
              <span class="pc-user-name">{{ item.user.displayName || 'Unnamed user' }}</span>
              @if (item.invited) { <span class="pc-user-note">Invitation pending</span> }
            </div>
          </div>
        </td>
        <td><a class="pc-email" [href]="'mailto:' + item.user.emailAddress">{{ item.user.emailAddress }}</a></td>
        <td><span class="pc-role-badge">{{ item.roleName || 'No role' }}</span></td>
        <td><span class="pc-status" [ngClass]="item.statusClass"><span></span>{{ item.statusLabel }}</span></td>
        <td class="pc-actions-column">
          <button mat-icon-button [matMenuTriggerFor]="rowMenu" aria-label="Actions for this user" (click)="$event.stopPropagation()">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #rowMenu="matMenu">
            @if (canEditUsers) {
              <button mat-menu-item (click)="editUser(item)" [disabled]="item.invited">
                <mat-icon>edit</mat-icon><span>Edit user</span>
              </button>
            }
            @if (canEditUserRoles) {
              <button mat-menu-item (click)="updateRole(item)" [disabled]="item.invited">
                <mat-icon>admin_panel_settings</mat-icon><span>Change role</span>
              </button>
            }
            <button mat-menu-item (click)="sendResetPasswordLink(item)">
              <mat-icon>lock_reset</mat-icon><span>Send password reset</span>
            </button>
            @if (canAddUsers && canSeeInviteToOtherCompanies) {
              <button mat-menu-item (click)="inviteToOtherCompany(item)" [disabled]="item.invited">
                <mat-icon>outgoing_mail</mat-icon><span>Invite to another company</span>
              </button>
            }
            @if (canEnableDisableUsers && !item.invited) {
              <button mat-menu-item (click)="item.user.disabled ? enableSelectedRows(item) : disableSelectedRows(item)">
                <mat-icon>{{ item.user.disabled ? 'person_outline' : 'person_off' }}</mat-icon>
                <span>{{ item.user.disabled ? 'Enable user' : 'Disable user' }}</span>
              </button>
            }
          </mat-menu>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr><td colspan="6" class="pc-empty">{{ tableLoading ? 'Loading users…' : 'No users to show.' }}</td></tr>
    </ng-template>
  </p-table>
</div>
